import { Aspect } from '@teambit/harmony';

export const DeprecationAspect = Aspect.create({
  id: 'teambit.component/deprecation',
  dependencies: [],
  defaultConfig: {},
});

export default DeprecationAspect;
